import { Navigate} from "react-router-dom"

function Protecte({ children }) {   
    return localStorage.getItem("user")!== null ? children : <Navigate to="/login" />;
}
export default Protecte